import { camelize } from 'utils/textFormats';

export const normalizeTicketData = (ticketData) => {
    const {
        ticketSale,
        cart: { lineItems, totalAmount, tax },
        ticketType,
        ticketOrder: { orderNumber },
    } = camelize(ticketData);

    let shouldHideReceiptTitle = false;

    const tickets = ticketSale.map(({ ticketTypeId }, idx) => {
        const {
            ticketType: { name, displayDate, displayDateEnd, nonDollar },
        } = ticketType[ticketTypeId];

        const { perUnit, quantity, fee, amount } = lineItems[idx];

        shouldHideReceiptTitle = shouldHideReceiptTitle || !!parseInt(nonDollar, 10);

        return {
            name,
            startDate: displayDate,
            endDate: displayDateEnd,
            saleData: {
                price: perUnit,
                quantity: parseInt(quantity, 10),
                total: amount,
                ...(fee ? { fee } : {}),
            },
        };
    });

    const normalizedTicketData = {
        totalAmount,
        tax,
        orderNumber,
        tickets,
        shouldHideReceiptTitle,
    };

    return normalizedTicketData;
};
